module.exports = __webpack_public_path__ + "static/media/pedigree-node-settings.50ff2d27.svg";